import { usePricingData } from "../../../lib/useMockData";

export default function HeroSection() {
  const { heroData } = usePricingData();
  return (
    <section className="relative h-[320px] md:h-[420px] overflow-hidden">
      <img
        src={heroData.image}
        alt="料金・プラン"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-airdoa-navy/50 via-airdoa-navy/40 to-airdoa-navy/60" />

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-4">
        <p className="text-xs md:text-sm tracking-ultra text-airdoa-gold mb-3 opacity-0 animate-fade-in">
          PRICING &amp; PLANS
        </p>
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-serif font-bold text-white leading-tight opacity-0 animate-slide-up animation-delay-200">
          {heroData.title}
        </h1>
        <p className="mt-4 max-w-xl text-sm text-white/70 leading-relaxed opacity-0 animate-slide-up animation-delay-300">
          {heroData.subtitle}
        </p>
      </div>
    </section>
  );
}